import React from 'react';

import * as S from './Divider.styles';

export const Divider = ({ vertical = false, theme = '1', size = 's', length }) => {
  return (
    <S.Container theme={theme} size={size}>
      {!vertical && <S.HorizontalDivider length={length} />}
      {vertical && <S.VerticalDivider length={length} />}
    </S.Container>
  );
};
